import { render, staticRenderFns } from "./PaymentChannels.vue?vue&type=template&id=daba8f60&scoped=true&"
import script from "./PaymentChannels.vue?vue&type=script&lang=js&"
export * from "./PaymentChannels.vue?vue&type=script&lang=js&"
import style0 from "./PaymentChannels.vue?vue&type=style&index=0&id=daba8f60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daba8f60",
  null
  
)

export default component.exports